module.exports = __webpack_public_path__ + "static/media/baner.4d717e14.png";